import { maskMonetaryValue } from 'utils/stringUtils';

export const MINIMUM_LOAN_AMOUNT = 1000;
export const MAXIMUM_LOAN_AMOUNT_1_RANGE = 50000;
export const STEP_1_RANGE = 50;
export const STEP_2_RANGE = 50;
export const STEP_3_RANGE = 35;
export const MAXIMUM_STEPS = STEP_1_RANGE + STEP_2_RANGE + STEP_3_RANGE;
export const MAXIMUM_LOAN_AMOUNT_2_RANGE = 150000;
export const MAXIMUM_LOAN_AMOUNT_RANGE = 500000;
export const MINIMUM_STEP_LOAN_AMOUNT = 1000;
export const MEDIUM_STEP_LOAN_AMOUNT = 2000;
export const MAXIMUM_STEP_LOAN_AMOUNT = 10000;
export const MIN_LOAN_FOR_PORTAL_WITH_SMALL_LOAN_PROGRAM = 2000;
export const MIN_LOAN_FOR_PORTAL = 15000;
export const MAX_LOAN_FOR_PORTAL = 500000;
export const MIN_LOAN_AMOUNT = 1000;

export const LOAN_SLIDER_MARKS = [
  {
    value: 0,
    label: maskMonetaryValue(MIN_LOAN_AMOUNT),
  },
  {
    value: STEP_1_RANGE,
    label: maskMonetaryValue(MAXIMUM_LOAN_AMOUNT_1_RANGE),
  },
  {
    value: STEP_1_RANGE + STEP_2_RANGE,
    label: maskMonetaryValue(MAXIMUM_LOAN_AMOUNT_2_RANGE),
  },
  {
    value: STEP_1_RANGE + STEP_2_RANGE + STEP_3_RANGE,
    label: maskMonetaryValue(MAXIMUM_LOAN_AMOUNT_RANGE),
  },
];
